import { putMe } from '../../services/api/me.api';
import { PUT_ME_REQUEST, PUT_ME_SUCCESS, PUT_ME_FAILURE } from '../types';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
	},

	mutations: {
		[PUT_ME_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
		},
		[PUT_ME_SUCCESS](state) {
			state.isLoading = false;
		},
		[PUT_ME_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async updateUserProfile({ commit }, params) {
			try {
				commit(PUT_ME_REQUEST);
				await putMe(params);
				commit(PUT_ME_SUCCESS);
			} catch (error) {
				commit(PUT_ME_FAILURE, error);
			}
		},
	},
};